import View from "./view.js";
import OrbitViewport from "../viewports/orbit-viewport.js";
import OrbitController from "../controllers/orbit-controller.js";
export default class OrbitView extends View {
    static { this.displayName = 'OrbitView'; }
    constructor(props = {}) {
        super(props);
        this.props.orbitAxis = props.orbitAxis || 'Z';
    }
    get ViewportType() {
        return OrbitViewport;
    }
    get ControllerType() {
        return OrbitController;
    }
}
